import React from "react";
import { Link } from "react-router-dom";

function VerifiedEmail() {
  return (
    <div className="flex flex-col justify-center text-center bg-[#D4DDCC] h-[100vh] gap-4 text-[#295700] md:px-96 leading-8">
      <h1 className="font-bold  text-3xl">Account Activated</h1>
      <div className="bg-[#295700] w-fit p-4 mx-auto rounded-full">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="white"
          className="w-20 h-20"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
          />
        </svg>
      </div>
      <p>
        Thank you. Your email has been verified. Your account is now active.
        Please use the link below to login to your account.
      </p>
      <button className="w-fit mx-auto rounded-md px-4 py-2 bg-[#295700] text-white mt-4">
        <Link to="/signin"> LOGIN TO YOUR ACCOUNT </Link>
      </button>
    </div>
  );
}

export default VerifiedEmail;
